import React, { FC } from 'react';
import {
	ACC_AUDIT_CHANGE_APPLY_STATUSES,
	ACC_AUDIT_MATCH_STATUSES,
} from '../../utils/AssetCycleUtils';

const getStatusColor = (statusKey) => {
	switch (statusKey) {
		case 'completed':
		case 'readyForApproval':
		case ACC_AUDIT_MATCH_STATUSES.MATCHED:
		case ACC_AUDIT_CHANGE_APPLY_STATUSES.Logged:
			return '#135200';
		case 'approved':
		case 'changesApplied':
		case ACC_AUDIT_MATCH_STATUSES.NeedsVerification:
		case ACC_AUDIT_MATCH_STATUSES.Missing:
		case ACC_AUDIT_CHANGE_APPLY_STATUSES.Failed:
		case ACC_AUDIT_CHANGE_APPLY_STATUSES.ChangesApplied:
			return '#FFFFFF';
		case ACC_AUDIT_MATCH_STATUSES.MatchedWithVariance:
			return '#262626';
		case ACC_AUDIT_MATCH_STATUSES.NewAsset:
		case 'new':
		case 'notStarted':
		case 'inProgress':
		case ACC_AUDIT_CHANGE_APPLY_STATUSES.RunInProgress:
		default:
			return '#000000D9';
	}
};

const getBackgroundColor = (statusKey) => {
	switch (statusKey) {
		case 'inProgress':
		case ACC_AUDIT_CHANGE_APPLY_STATUSES.RunInProgress:
			return '#EFDBFF';
		case 'completed':
		case 'readyForApproval':
		case ACC_AUDIT_MATCH_STATUSES.MATCHED:
		case ACC_AUDIT_CHANGE_APPLY_STATUSES.Logged:
			return '#F3F9E1';
		case 'approved':
		case ACC_AUDIT_CHANGE_APPLY_STATUSES.ChangesApplied:
			return '#389E0D';
		case 'changesApplied':
			return '#135200';
		case ACC_AUDIT_MATCH_STATUSES.MatchedWithVariance:
			return '#FFBB96';
		case ACC_AUDIT_MATCH_STATUSES.NeedsVerification:
		case ACC_AUDIT_CHANGE_APPLY_STATUSES.Failed:
			return '#FF4D4F';
		case ACC_AUDIT_MATCH_STATUSES.Missing:
			return '#621B1C';
		case ACC_AUDIT_MATCH_STATUSES.NewAsset:
		case 'new':
		case 'notStarted':
		default:
			return '#F0F0F0';
	}
};

const GeneralStatusDisplay: FC<any> = ({
	statusKey,
	statusLabel,
	className = '',
}): React.ReactElement => {
	return (
		<div className={`footnoteregular flex whitespace-nowrap leading-normal  ${className}`}>
			<span
				style={{
					color: getStatusColor(statusKey),
					backgroundColor: getBackgroundColor(statusKey),
					padding: '4px 12px',
					borderRadius: 16,
				}}
			>
				{statusLabel || statusKey}
			</span>
		</div>
	);
};

export default GeneralStatusDisplay;
